import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Repeat, User, Calendar, Trash2 } from "lucide-react";

const DOW_LABELS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const ordinal = (n) => (n === 1 ? "st" : n === 2 ? "nd" : n === 3 ? "rd" : "th");

/**
 * R121 recurring series list, rendered under the passes on the resident
 * parking page. Only shows active series — cancelled ones fall away.
 */
export function SeriesList({ series, onCancel }) {
  const active = series.filter((s) => s.active);
  if (active.length === 0) return null;

  return (
    <div className="mt-4 pt-4 border-t border-white/10" data-testid="series-list">
      <div className="flex items-center gap-2 overline mb-2">
        <Repeat className="h-3.5 w-3.5 text-indigo-400" />
        Recurring ({active.length})
      </div>
      <div className="space-y-2">
        {active.map((s) => (
          <div key={s.id}
               className="rounded-lg border border-indigo-500/20 bg-indigo-500/[0.03] p-3 flex flex-wrap items-center gap-3 justify-between"
               data-testid={`series-${s.id}`}>
            <div className="flex-1 min-w-[240px]">
              <div className="flex items-center gap-2 flex-wrap">
                <User className="h-3.5 w-3.5 text-zinc-500" />
                <span className="text-sm font-medium">{s.guest_name}</span>
                <Badge variant="outline" className="border-indigo-500/30 text-indigo-300">{s.pattern}</Badge>
              </div>
              <div className="text-xs text-zinc-400 mt-1 font-mono">{s.plate}</div>
              <div className="text-[11px] text-zinc-500 mt-1 inline-flex items-center gap-1">
                <Calendar className="h-3 w-3" />
                {s.pattern === "weekly"
                  ? `Every ${(s.days_of_week || []).map((d) => DOW_LABELS[d]).join(", ")} at ${s.time_of_day}`
                  : `Every ${s.day_of_month}${ordinal(s.day_of_month)} at ${s.time_of_day}`}
              </div>
              {s.next_run_at && (
                <div className="text-[10px] text-emerald-400 mt-0.5">
                  Next auto-issue: {new Date(s.next_run_at).toLocaleString()}
                </div>
              )}
            </div>
            <Button size="sm" variant="outline"
                    className="border-red-500/30 text-red-300 hover:bg-red-500/10"
                    onClick={() => onCancel(s.id)}
                    data-testid={`series-cancel-${s.id}`}>
              <Trash2 className="h-3.5 w-3.5" />
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
